import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleWatchClick = () => {
    console.log('Watch button clicked from header');
    
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const cardsSection = document.getElementById('sports-cards');
        if (cardsSection) {
          cardsSection.scrollIntoView({ behavior: 'smooth' });
          console.log('Scrolled to cards section after navigation');
        } else {
          console.log('Cards section not found after navigation');
        }
      }, 100);
    } else {
      // If we're already on home page, just scroll
      const cardsSection = document.getElementById('sports-cards');
      if (cardsSection) {
        cardsSection.scrollIntoView({ behavior: 'smooth' });
        console.log('Scrolled to cards section on home page');
      } else {
        console.log('Cards section not found on home page');
      }
    }
  };

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="bg-slate-panel/80 backdrop-blur-md border-b border-line sticky top-0 z-50 text-white">
      
      <nav className="container-custom">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <img src="/assets/logo.png" alt="IBT Sports" className="w-12 h-12" />

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`nav-link font-medium font-display hover:text-primary ${
                  location.pathname === item.href
                    ? 'text-primary border-b-2 border-primary'
                    : 'text-gray-200'
                }`}
                aria-current={location.pathname === item.href ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
            <button className="btn-pill-primary font-display" onClick={handleWatchClick}>
              Watch Now
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-200 hover:text-primary focus:outline-none focus:text-primary"
            >
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                  />
                ) : (
                  <path
                    fillRule="evenodd"
                    d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-slate-panel border-t border-line">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block px-3 py-2 text-base font-medium font-display transition duration-300 hover:text-primary hover:bg-ink/40 rounded-md ${
                    location.pathname === item.href
                      ? 'text-primary bg-ink/40'
                      : 'text-gray-200'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-3 py-2">
                <button className="btn-pill-primary w-full font-display" onClick={handleWatchClick}>
                  Watch Now
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header; 